import React from 'react'
import CIcon from '@coreui/icons-react'
import { cilList, cilListNumbered, cilSpeedometer } from '@coreui/icons'
import { CNavItem } from '@coreui/react'

const _nav = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/dashboard',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'State Machine',
    to: '/statemachine/list',
    icon: <CIcon icon={cilListNumbered} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Contents',
    to: '/content/list',
    icon: <CIcon icon={cilList} customClassName="nav-icon" />,
  },
]

export default _nav
